// @mui
import { styled, keyframes } from '@mui/material/styles';
import { Container, Typography, Box } from '@mui/material';
// components
import Logo from '../components/Logo';
import Page from '../components/Page';
// sections
import { LoginForm } from '../sections/auth/login';

// ----------------------------------------------------------------------

const fadeUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const RootStyle = styled('div')({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#f5f5f7',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '-30%',
    left: '-10%',
    width: '60%',
    height: '70%',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(0,122,255,0.07) 0%, transparent 70%)',
    pointerEvents: 'none',
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: '-20%',
    right: '-10%',
    width: '55%',
    height: '65%',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(100,210,255,0.08) 0%, transparent 70%)',
    pointerEvents: 'none',
  },
});

const GlassCard = styled('div')({
  width: '100%',
  maxWidth: 420,
  // background: 'rgba(255, 255, 255, 0.85)',
  backdropFilter: 'blur(32px)',
  WebkitBackdropFilter: 'blur(32px)',
  borderRadius: 24,
  // border: '1px solid rgba(255,255,255,0.9)',
  // boxShadow: '0 4px 6px rgba(0,0,0,0.04), 0 20px 60px rgba(0,0,0,0.08)',
  padding: '48px 44px',
  animation: `${fadeUp} 0.7s cubic-bezier(0.22, 1, 0.36, 1) both`,
});

export default function Login() {
  return (
    <Page title="Register">
      <RootStyle>
        <GlassCard>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Logo sx={{ width: '130px', height: '70px' }} />
          </Box>

          <Typography
            variant="h4"
            sx={{
              fontFamily: '"SF Pro Display", -apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif',
              fontWeight: 400,
              fontSize: '1.75rem',
              color: '#1d1d1f',
              lineHeight: 1.2,
              mb: 5,
              textAlign: 'center',
            }}
          >
            Sign In to Alis Build
          </Typography>

          <LoginForm />
        </GlassCard>
      </RootStyle>
    </Page>
  );
}
